import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Modal } from 'react-bootstrap'

import { formatMoney, notify } from 'helpers/helpers'
import { httpOk, GET, POST, PUT } from 'helpers/api'

// Наши договоры с операторами. Клиент их не видит: он подключает один «Mison SMS»,
// а через какой договор уйдёт сообщение, решает роутер по стране номера.
// Новая страна открывается здесь: строка + драйвер + цена на вкладке «Цены SMS».
const emptyItem = {
	code: '',
	name: '',
	driver: 'playmobile',
	country_codes: [],
	cost_price: '',
	priority: 100,
	is_selectable: false,
	is_active: true,
	config: { login: '', password: '', key: '', originator: '', url: '' },
}

function Index() {
	const { t } = useTranslation()
	const [data, setData] = useState([])
	const [drivers, setDrivers] = useState([])
	const [countries, setCountries] = useState([])
	const [modal, setModal] = useState(false)
	const [selectedItem, setSelectedItem] = useState(emptyItem)
	const [testModal, setTestModal] = useState(false)
	const [testItem, setTestItem] = useState({ code: '', phone: '', message: '' })

	// Адрес по умолчанию у каждого драйвера свой, и вписать вместо него корень сайта —
	// самая лёгкая ошибка при заведении канала: шлюз ответит 500, а выглядит как «не работает».
	const driverUrls = {
		'playmobile': 'https://send.smsxabar.uz/broker-api/send',
		'smsfly': 'https://api.smsfly.uz/api/compat/send',
		'smsfly_key': 'https://api.smsfly.uz',
	}

	async function loadData() {
		const response = await GET('/admin/sms-upstreams', {}, { loader: true })
		if (httpOk(response)) {
			setData(response.data?.data || [])
			setDrivers(response.data?.drivers || [])
			setCountries(response.data?.countries || [])
		}
	}

	function toggleModal(bool = false, item = emptyItem) {
		setSelectedItem({
			...emptyItem,
			...item,
			cost_price: item.cost_price ?? '',
			country_codes: item.country_codes || [],
			// Пароль наружу не отдаётся: пустое поле = «оставить прежний»
			// Секреты сервер наружу не отдаёт: поля пустые, пустое = «оставить прежнее»
			config: { ...emptyItem.config, ...(item.config || {}), password: '', key: '' },
		})
		setModal(bool)
	}

	function toggleCountry(code) {
		setSelectedItem(prev => {
			const list = prev.country_codes.includes(code)
				? prev.country_codes.filter(item => item !== code)
				: [...prev.country_codes, code]
			return { ...prev, 'country_codes': list }
		})
	}

	async function save(e) {
		e.preventDefault()

		if (selectedItem.country_codes.length === 0) {
			notify(t('sms_countries'))
			return
		}

		const payload = {
			...selectedItem,
			cost_price: String(selectedItem.cost_price || 0).replace(/\s/g, ''),
		}

		const response = selectedItem.id
			? await PUT('/admin/sms-upstreams', payload, { loader: true })
			: await POST('/admin/sms-upstreams', payload, { loader: true })

		if (httpOk(response)) {
			toggleModal(false)
			loadData()
		}
	}

	// Без тестовой отправки новый договор проверяется только на живом клиенте
	async function sendTest(e) {
		e.preventDefault()
		const response = await POST('/admin/sms-upstreams/test', testItem, { loader: true, notification: false })
		if (httpOk(response)) {
			notify(response.data.message, 'success')
			setTestModal(false)
		}
	}

	useEffect(() => {
		loadData()
	}, [])

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<h4 className="vertical-center">{t('sms_upstreams')} [{data.length}]</h4>
				<button className="btn-rounded btn btn-primary" onClick={() => toggleModal(true)}>
					{t('create')}
				</button>
			</div>

			<div className="card">
				<div className="card-body">
					<div className="table-responsive">
						<table className="table table-bordered">
							<thead>
								<tr>
									<th style={{ 'width': '20%' }}>{t('name')}</th>
									<th style={{ 'width': '12%' }}>{t('sms_driver')}</th>
									<th style={{ 'width': '12%' }}>{t('sms_countries')}</th>
									<th style={{ 'width': '12%' }} className="text-end">{t('sms_cost')}</th>
									<th style={{ 'width': '10%' }} className="text-center">{t('sms_priority')}</th>
									<th style={{ 'width': '12%' }} className="text-end">{t('sms_status_sent')}</th>
									<th style={{ 'width': '10%' }} className="text-center">{t('status')}</th>
									<th style={{ 'width': '12%' }} className="text-center"></th>
								</tr>
							</thead>
							<tbody>
								{data.map((item, index) => (
									<tr key={index}>
										<td>
											<div className="fw-600">{item.name}</div>
											<div className="text-muted" style={{ 'fontSize': '.75rem' }}>{item.code}</div>
										</td>
										<td>{item.driver}</td>
										<td>{(item.country_codes || []).join(', ')}</td>
										<td className="text-end">{formatMoney(item.cost_price)}</td>
										<td className="text-center">{item.priority}</td>
										<td className="text-end">{formatMoney(item.sent_this_month)}</td>
										<td className="text-center">
											<span className={'badge ' + (item.is_active ? 'bg-success' : 'bg-secondary')}>
												{item.is_active ? t('active') : t('inactive')}
											</span>
										</td>
										<td className="text-center">
											<div className="d-flex justify-content-center gap-2">
												<button className="btn btn-sm btn-outline-primary"
													onClick={() => { setTestItem({ 'code': item.code, 'phone': '', 'message': '' }); setTestModal(true) }}>
													<i className="uil-message" />
												</button>
												<button className="btn btn-sm btn-outline-dark"
													onClick={() => toggleModal(true, item)}>
													<i className="uil-edit-alt" />
												</button>
											</div>
										</td>
									</tr>
								))}
								{data.length === 0 &&
									<tr><td colSpan="8" className="text-center text-muted">{t('list_empty')}</td></tr>
								}
							</tbody>
						</table>
					</div>
				</div>
			</div>

			{/* MODAL: канал */}
			<Modal show={modal} animation={false} centered dialogClassName="update-modal-width"
 onHide={() => setModal(false)}>
				<Modal.Header closeButton>
					<Modal.Title>{selectedItem.id ? t('edit') : t('create')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={save} autoComplete="off">
						<div className="row">
							<div className="form-group col-md-6">
								<label>{t('name')}<span className="required-mark">*</span></label>
								<input type="text" className="form-control" value={selectedItem.name}
									onChange={(e) => setSelectedItem({ ...selectedItem, 'name': e.target.value })} />
							</div>
							<div className="form-group col-md-6">
								<label>{t('code')}<span className="required-mark">*</span></label>
								<input type="text" className="form-control" value={selectedItem.code}
									disabled={!!selectedItem.id}
									placeholder="mison_uz"
									onChange={(e) => setSelectedItem({ ...selectedItem, 'code': e.target.value })} />
							</div>
						</div>

						<div className="row">
							<div className="form-group col-md-6">
								<label>{t('sms_driver')}<span className="required-mark">*</span></label>
								<select className="form-select" value={selectedItem.driver}
									onChange={(e) => setSelectedItem({ ...selectedItem, 'driver': e.target.value })}>
									{drivers.map((driver, index) => (
										<option value={driver.value} key={index}>{driver.name}</option>
									))}
								</select>
							</div>
							<div className="form-group col-md-3">
								<label>{t('sms_cost')}</label>
								<input type="number" className="form-control" value={selectedItem.cost_price}
									onChange={(e) => setSelectedItem({ ...selectedItem, 'cost_price': e.target.value })} />
							</div>
							<div className="form-group col-md-3">
								<label>{t('sms_priority')}</label>
								<input type="number" className="form-control" value={selectedItem.priority}
									onChange={(e) => setSelectedItem({ ...selectedItem, 'priority': e.target.value })} />
							</div>
						</div>

						<div className="form-group">
							<label>{t('sms_countries')}<span className="required-mark">*</span></label>
							<div className="d-flex flex-wrap gap-2">
								{countries.map((country, index) => (
									<button type="button" key={index}
										className={'btn btn-sm ' + (selectedItem.country_codes.includes(country.code) ? 'btn-primary' : 'btn-outline-secondary')}
										onClick={() => toggleCountry(country.code)}>
										{country.name} {country.dial_prefix ? `+${country.dial_prefix}` : ''}
									</button>
								))}
							</div>
						</div>

						{/* Заполняется то, что требует драйвер: по ключу — API-ключ,
							по логину и паролю — пара логин/пароль. Лишнее просто не трогаем. */}
						{selectedItem.driver === 'smsfly_key'
							? <div className="row">
								<div className="form-group col-md-12">
									<label>API-ключ<span className="required-mark">*</span></label>
									<input type="password" className="form-control" value={selectedItem.config.key}
										placeholder={selectedItem.config.has_key ? '••••••' : ''}
										onChange={(e) => setSelectedItem({ ...selectedItem, 'config': { ...selectedItem.config, 'key': e.target.value } })} />
								</div>
							</div>
							: <div className="row">
								<div className="form-group col-md-6">
									<label>Login</label>
									<input type="text" className="form-control" value={selectedItem.config.login}
										onChange={(e) => setSelectedItem({ ...selectedItem, 'config': { ...selectedItem.config, 'login': e.target.value } })} />
								</div>
								<div className="form-group col-md-6">
									<label>Password</label>
									<input type="password" className="form-control" value={selectedItem.config.password}
										placeholder={selectedItem.config.has_password ? '••••••' : ''}
										onChange={(e) => setSelectedItem({ ...selectedItem, 'config': { ...selectedItem.config, 'password': e.target.value } })} />
								</div>
							</div>
						}

						<div className="row">
							<div className="form-group col-md-6">
								<label>Originator</label>
								<input type="text" className="form-control" value={selectedItem.config.originator}
									placeholder="3700"
									onChange={(e) => setSelectedItem({ ...selectedItem, 'config': { ...selectedItem.config, 'originator': e.target.value } })} />
							</div>
							<div className="form-group col-md-6">
								<label>URL</label>
								<input type="text" className="form-control" value={selectedItem.config.url}
									placeholder={driverUrls[selectedItem.driver] || ''}
									onChange={(e) => setSelectedItem({ ...selectedItem, 'config': { ...selectedItem.config, 'url': e.target.value } })} />
								<div className="text-muted" style={{ 'fontSize': '.78rem', 'marginTop': '3px' }}>
									{t('sms_url_hint')}
								</div>
							</div>
						</div>

						<div className="d-flex gap-3">
							<div className="form-check form-switch form-switch-lg">
								<input type="checkbox" className="form-check-input" id="isActive"
									checked={!!selectedItem.is_active}
									onChange={(e) => setSelectedItem({ ...selectedItem, 'is_active': e.target.checked })} />
								<label className="form-check-label" htmlFor="isActive">{t('active')}</label>
							</div>
						</div>

						<div className="d-flex gap-2 w-100 mt-3">
							<button type="button" className="btn btn-outline-warning w-100" onClick={() => setModal(false)}>
								{t('cancel')}
							</button>
							<button type="submit" className="btn btn-primary w-100">{t('save')}</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>

			{/* MODAL: тестовая отправка */}
			<Modal show={testModal} animation={false} centered onHide={() => setTestModal(false)}>
				<Modal.Header closeButton>
					<Modal.Title>{t('sms_test_send')} — {testItem.code}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={sendTest} autoComplete="off">
						<div className="form-group">
							<label>{t('phone')}<span className="required-mark">*</span></label>
							<input type="text" className="form-control" value={testItem.phone}
								placeholder="998901234567"
								onChange={(e) => setTestItem({ ...testItem, 'phone': e.target.value })} />
						</div>
						<div className="form-group">
							<label>{t('text')}</label>
							<textarea className="form-control" rows="3" value={testItem.message}
								onChange={(e) => setTestItem({ ...testItem, 'message': e.target.value })} />
						</div>
						<div className="d-flex gap-2 w-100 mt-3">
							<button type="button" className="btn btn-outline-warning w-100" onClick={() => setTestModal(false)}>
								{t('cancel')}
							</button>
							<button type="submit" className="btn btn-primary w-100">{t('send')}</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
		</>
	)
}

export default Index
